import { render } from "./DownloadSvg.vue?vue&type=template&id=3f570c0f"
import script from "./DownloadSvg.vue?vue&type=script&lang=js"
export * from "./DownloadSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__